import { defineLocaleTargets } from '@accesso/cc-std-lib';

export const TimeLocales = defineLocaleTargets('time', <const>{
	allTimes: '',
	availableTimes: '',
	chooseYourTime: '',
	filterTimes: '',
	seeLessTimes: '',
	seeMoreTimes: '',
});
